export default __webpack_public_path__ + "static/media/Hitavada.61bcf1a1.jpg";